import {CSSProperties, FC} from 'react';


export interface IIconLightsLowBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLightsLowBmw: FC<IIconLightsLowBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M13.334 4c.322 0 .598.23.656.547l.068.37c.815 4.602.816 9.366.001 14.158l-.069.377a.667.667 0 0 1-.656.548c-5.146 0-9.333-3.59-9.333-8 0-4.411 4.187-8 9.333-8Zm5.657 6.571-3.333-2a.666.666 0 1 1 .686-1.143l3.333 2a.666.666 0 1 1-.686 1.143Zm.686 2.857-3.333-2a.666.666 0 1 0-.686 1.143l3.333 2a.666.666 0 1 0 .686-1.143Zm-3.333 2 3.333 2a.667.667 0 1 1-.686 1.144l-3.333-2a.667.667 0 1 1 .686-1.144Z" clipRule="evenodd" />
        </svg>
    );
};
